module.exports = __webpack_public_path__ + "Healthy.66465b2e06bb3673a5b9edcd16ef7e0d.hashedasset.svg";